import { createSlice } from '@reduxjs/toolkit';

const tutorialsSlice = createSlice({
  name: 'tutorials',
  initialState: {
    tutorials: [],
  },
  reducers: {
    setTutorials: (state, action) => {
      state.tutorials = action.payload;
    },
    deleteTutorial: (state, action) => {
      state.tutorials = state.tutorials.filter(tutorial => tutorial.id !== action.payload);
    }
  },
});

export const { setTutorials, deleteTutorial } = tutorialsSlice.actions;

export default tutorialsSlice.reducer;
